import { restClient } from '../config/restClient'
import { fetchInterviewEvents, createInterviewEvent } from '../../InterviewRequests/graphql/interviewEvents'
import { InterviewEventPeriod, InterviewEventStatusFilter } from '../../InterviewRequests/helpers/interviewEventHelpers'

const endpoint = interviewRequestId => `/api/company/v2/interview_requests/${interviewRequestId}/interview_events`

export const fetchInterviewRequestInterviewEvents = async (interviewRequestId, sortBy, sortDirection, interviewSource) => {
  const now = new Date().toISOString()

  const { interviewEvents: { nodes: pending } = { interviewEvents: { nodes: [] } } } = await fetchInterviewEvents({
    interviewRequestId,
    sortBy,
    sortDirection,
    interviewSource,
    statuses: [InterviewEventStatusFilter.Pending],
    period: InterviewEventPeriod.Pending,
    eventsAfter: now,
  })

  const { interviewEvents: { nodes: upcoming } = { interviewEvents: { nodes: [] } } } = await fetchInterviewEvents({
    interviewRequestId,
    sortBy,
    sortDirection,
    interviewSource,
    statuses: [InterviewEventStatusFilter.Confirmed],
    period: InterviewEventPeriod.Upcoming,
    eventsAfter: now,
  })

  const { interviewEvents: { nodes: past } = { interviewEvents: { nodes: [] } } } = await fetchInterviewEvents({
    interviewRequestId,
    sortBy,
    sortDirection,
    interviewSource,
    period: InterviewEventPeriod.Past,
    eventsBefore: now,
  })

  const combinedInterviewEvents = pending.concat(upcoming, past)

  return combinedInterviewEvents
}

export const createInterviewRequestInterviewEvent = async input => {
  const data = await createInterviewEvent({ input })

  return data.createInterviewEvent
}

export const patchInterviewRequestInterviewEvent = async (interviewRequestId, interviewEventId, data) => {
  const response = await restClient(`${endpoint(interviewRequestId)}/${interviewEventId}`, {
    method: 'PATCH',
    data,
  })
  return response.data
}
